import React from 'react';
//import AvatarImage from 'assets/images/sampleAvatar.png';
import AvatarImage from 'assets/images/seyedAvatar.png';
import {IconButton, Notification} from 'components/common/uiKit';
import {serverUrl} from 'services/network';
import {UserApi} from 'services/network/api';

class Avatar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };
    }

    sizeHandle(size) {
        switch (size) {
            case 'large':
                return 'avatar-lg';
            case 'small':
                return 'avatar-sm';
            default:
                return 'avatar';
        }
    }

    _handleImageUpload = (evt) => {
        const file = evt.target.files;
        if (file) {
            this.setState({loading: true});

            let formData = new FormData();
            formData.append("AvatarFile", file[0]);

            UserApi.ChangeAvatar(formData)
                .then(res => {
                    if (res && res.status) {
                        const {data} = res;
                        const {onChange} = this.props;
                        onChange(data);
                        Notification('success', 'Succeed');
                    }
                }).finally(() => {
                this.setState({loading: false});
            });
        }
    };

    render() {
        const {loading} = this.state;
        let {size, editAllow, src} = this.props;
        let avatarSrc = '';

        if (src) {
            avatarSrc = `url(${src.split('\\').join('//')})`;
        } else {
            avatarSrc = `url(${AvatarImage})`
        }

        return (
            <div id='Avatar' className={`bg-fade-gray1-dark ${this.sizeHandle(size)}`}
                 style={{backgroundImage: avatarSrc, position: 'relative'}}>
                {editAllow &&
                <div onClick={() => global.document.getElementById('browseImageFileButton').click()}>
                    <input
                        id="browseImageFileButton"
                        type="file"
                        accept="image/*"
                        onChange={this._handleImageUpload}
                        hidden
                    />
                    <IconButton icon='pen' color='primary' loading={loading} style={{
                        position: 'absolute',
                        fontSize: 13,
                        left: -5,
                        bottom: -5,
                        backgroundColor: '#eee'
                    }}/>

                </div>
                }
            </div>
        );


        return (
            <div>
                <a data-menu="menu-main" className="bg-fade-gray1-dark shadow-xl preload-img"
                   data-src={AvatarImage}>
                </a>
            </div>
        );
    }
}

export default Avatar;